import { createFileRoute } from "@tanstack/react-router";
import { AestheticBioHomepage } from "../pages/AestheticBioHomepage";

const title = "Letras Aesthetic para Copiar y Pegar | Aesthetic Bio Maker";
const description =
  "Crea letras aesthetic para copiar y pegar y bios aesthetic listas para usar. Elige fuentes bonitas, símbolos y decoraciones y copia tu texto gratis.";

export const Route = createFileRoute("/es")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" }
    ],
    links: [
      { rel: "canonical", href: "https://aestheticbiomaker.com/es/" },
      {
        rel: "alternate",
        hrefLang: "es",
        href: "https://aestheticbiomaker.com/es/"
      },
      {
        rel: "alternate",
        hrefLang: "en",
        href: "https://aestheticbiomaker.com/"
      },
      {
        rel: "alternate",
        hrefLang: "x-default",
        href: "https://aestheticbiomaker.com/"
      }
    ]
  }),
  component: SpanishHomepage
});

function SpanishHomepage() {
  return <AestheticBioHomepage locale="es" />;
}
